import { useRouter } from '@gef-ui/router-core';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useCalculateTopOffset } from '../../../hooks/useCalculateTopOffset';
import useIsDesktop from '../../../hooks/useIsDesktop';
import { Appbar } from '../../Appbar';
import { Clientbar } from '../../Clientbar';
import { Sidebar } from '../../Sidebar';
import TopOffsetContextProvider from '../../TopOffsetContextProvider';
import { NAVBAR } from '../../sizeConstants';
import { passSx, sxPropType, useDefaultComponentValue } from '../../utils';
export const MainStyle = styled('main')(({ theme, topOffset, sidebarWidth })=>{
    return {
        flexGrow: 1,
        paddingTop: 24 + topOffset,
        paddingBottom: 24,
        [theme.breakpoints.up('xs')]: {
            width: `100%`,
            paddingLeft: 25,
            paddingRight: 25
        },
        [theme.breakpoints.up('md')]: {
            paddingTop: 24 + topOffset,
            paddingBottom: 24,
            width: `calc(100% - ${NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px)`,
            transition: theme.transitions.create('margin-left', {
                duration: theme.transitions.duration.shorter
            })
        },
        [theme.breakpoints.up('xl')]: {
            width: `calc(100% - ${sidebarWidth}px)`
        }
    };
});
const COMPONENT_NAME = 'Dashboard';
const Dashboard = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { children, AppbarProps, ClientbarProps, SidebarProps, appbarRightSideElements, clientBarElement, sidebarElement, sidebarWidth = NAVBAR.DEFAULT_DASHBOARD_WIDTH, sx } = props;
    const [open, setOpen] = useState(false);
    const { pathname } = useRouter().useLocation();
    const isDesktop = useIsDesktop();
    // biome-ignore lint/correctness/useExhaustiveDependencies: intended
    useEffect(()=>{
        setOpen(false);
    }, [
        pathname,
        isDesktop
    ]);
    const { topOffset, appBarRef, clientBarRef } = useCalculateTopOffset();
    return /*#__PURE__*/ React.createElement(TopOffsetContextProvider, {
        topOffset: topOffset
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: [
            {
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh'
            },
            ...passSx(sx)
        ]
    }, /*#__PURE__*/ React.createElement(Appbar, {
        ref: appBarRef,
        withSidebar: !!sidebarElement,
        onOpenSidebar: ()=>setOpen(true),
        rightSideElements: appbarRightSideElements,
        ...AppbarProps
    }), clientBarElement && /*#__PURE__*/ React.createElement(Clientbar, {
        ref: clientBarRef,
        isDrawerOpen: open,
        ...ClientbarProps
    }, clientBarElement), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexGrow: 1
        }
    }, sidebarElement && /*#__PURE__*/ React.createElement(Sidebar, {
        isOpenSidebar: open,
        onCloseSidebar: ()=>setOpen(false),
        ...SidebarProps,
        appName: AppbarProps?.appName,
        sidebarWidth: sidebarWidth
    }, sidebarElement), /*#__PURE__*/ React.createElement(MainStyle, {
        topOffset: topOffset,
        sidebarWidth: sidebarWidth
    }, children))));
};
Dashboard.propTypes = {
    AppbarProps: PropTypes.object,
    ClientbarProps: PropTypes.object,
    SidebarProps: PropTypes.object,
    appbarRightSideElements: PropTypes.node,
    children: PropTypes.node,
    clientBarElement: PropTypes.node,
    sidebarElement: PropTypes.node,
    sidebarWidth: PropTypes.number,
    sx: sxPropType
};
export default Dashboard;
